import { render } from "./info.vue?vue&type=template&id=bddfb150&scoped=true"
import script from "./info.vue?vue&type=script&lang=js"
export * from "./info.vue?vue&type=script&lang=js"

import "./info.vue?vue&type=style&index=0&id=bddfb150&scoped=true&lang=css"

import exportComponent from "D:\\GitHub\\car\\web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bddfb150"]])

export default __exports__